import React from "react";

export default () => {
  return (
    <div className="mt-[30px] px-[20px] md:px-[40px]">
      <div className="flex justify-between Column_2 text-[#67748e] text-[14px]">
        <div className="text-center md:text-left">
          © 2023, made with 🖤 by Creative Tim for a better web.
        </div>
        <div className="flex gap-[20px] justify-center">
          <a href="#">Creative Tim</a>
          <a href="#">About us</a>
          <a href="#">Blog</a>
          <a href="#">Licence</a>
        </div>
      </div>
    </div>
  );
};
